import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  getMlmfuserMaster,
  getMlmfoutletMaster,
  getsubscriptionlistApi,
  updateMlmfCustomerMenuReq,
  saveMlmfCustomerMenuREQ,
  getresbasedmenumaster,
  deletesubscriptionmenuitem,
  getresbasedPopularMenumaster,
  subscriptionPlanId,
  subscriptionWalletAmount,
} from "../../../../apiservicescall/api";
import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import {
  // Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import Select from "react-select";

import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import swal from "sweetalert";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Edit } from "@material-ui/icons";

const SubscribersMaster = () => {
  // user master and selecter user value
  const [userlist, setuserlist] = useState([]);
  const [selectedusers, setSelectedusers] = useState([
    { label: "", value: "" },
  ]);

  const [menuid, setmenuid] = useState({ label: "", value: "" });

  const [outletlist, setoutletlist] = useState([]);
  const [selectedrestarant, setSelectedrestarant] = useState([
    { label: "", value: "" },
  ]);

  const [menulist, setMenuList] = useState([]);

  const [specialmenulist, setSpecialMenu] = useState([]);
  const [selectedspecialMenu, setSelectedSpecialMenu] = useState([
    { label: "", value: "" },
  ]);

  const [SubcriptionModal, setSubcriptionModal] = useState(false);
  const [deletepopup, setDeletepopup] = useState(false);
  const [subscriptionMenu, setSubcriptionMenu] = useState([]);

  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);

  const [errors, setErrors] = useState({
    // customerId: null,
    // restaurantId: null,
    // menuId: null,
    planId: null,
    totalAmount: null,
    deliveryType: null,
    actualCount: null,
    // weekDays: null,
    startDate: null,
    endDate: null,
  });
  const [formIsValid, setFormIsValid] = useState(false);

  const [menulistitem, setMenulistitem] = useState([
    {
      outletCode: 0,
      customerId: 0,
      plantId: "",
      startDate: "",
      endDate: "",
      weekDays: "",
      totalAmount: 0,
      deliveryType: "",
      actualCount: "",
      planName: "",
      endDate: new Date(),
      startDate: new Date(),
    },
  ]);
  //const [startDate, setStartDate] = useState(new Date());
  //   const [endDate, setEndDate] = useState(new Date());
  // const[calendatview,setCalendatview]=useState(false);
  // const[fromdatetodatevalidation,setFromdateTodateValidation]=useState(false);

  const [startDate, setDate] = useState(new Date());
  const [endDate, setendDate] = useState(new Date());
  // const [rangeStart, setRangeStart] = useState(new Date)
  // const defaultEndDate = new Date()
  // defaultEndDate.setDate(defaultEndDate.getDate()+7)
  //const [rangeEnd, setRangeEnd] = useState(defaultEndDate)
  const today = new Date();

  const [subPlanId, setSubPlanId] = useState([]);
  const [selectedplanId, setSelectedplanId] = useState({
    label: "",
    value: "",
  });

  const [totalamount, setTotalAmount] = useState({});

  const [deliveryType, setDeliveryType] = useState([
    { label: "Dunzo", value: "Dunzo" },
    { label: "Self Pickup", value: "Self Pickup" },
  ]);
  const [selcteDelivery, setSelectDelivery] = useState([
    { label: "", value: "" },
  ]);

  const [weekday, setWeekDays] = useState([
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Tuesday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday ", value: "Saturday " },
    { label: "Sunday", value: "Sunday" },
  ]);
  const [selcteWeekdays, setSelectWeekdays] = useState([
    { label: "", value: "" },
  ]);

  const [walletbal, setWalletBal] = useState([]);
  const [showamount, setShowAmount] = useState({});
  const [listmast, setListmast] = useState(false);

  useEffect(() => {
    getuserMaster();
    getRestarantmaster();
  }, []);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [approvalpopup, setApprovalPopup] = useState(false);
  const getuserMaster = async () => {
    let getsuserList = await getMlmfuserMaster();

    let getsuserValue = (getsuserList && getsuserList.data.data) || [];
    // console.log("getsuserValue", getsuserList);
    let dropdownusermaster =
      getsuserValue &&
      getsuserValue.map(({ id, name }) => ({
        label: name,
        value: id,
      }));
    setuserlist(dropdownusermaster);
  };

  const getRestarantmaster = async () => {
    let getsoutletList = await getMlmfoutletMaster();

    let getsoutletValue = (getsoutletList && getsoutletList.data.data) || [];

    let restarantmaster = getsoutletValue.map(({ id, name }) => ({
      label: name,
      value: id,
    }));
    // console.log("restarantmaster", restarantmaster);
    setoutletlist(restarantmaster);
  };

  const getRestarantmenulist = async (e) => {
    let restaurantId = selectedrestarant.value;

    let getresmenuid = await getresbasedmenumaster(restaurantId);

    let getresmenu = getresmenuid.data.data || [];

    let specialmenulist = getresmenu.map(({ id, name }) => ({
      label: name,
      value: id,
    }));
    setSpecialMenu(specialmenulist);
  };

  const getoutletSubscriptionMenulist = async (e) => {
    let restaurantId = selectedrestarant.value;
    let customerId = selectedusers.value;
    let getMenulist = await getsubscriptionlistApi(restaurantId, customerId);

    let getMenulistvalue = getMenulist.data.data || [];

    setMenuList(getMenulistvalue);

    console.log("menulist", menulist);
  };

  const getRestarantPopularlist = async (e) => {
    let restaurantId = selectedrestarant.value;

    let getresmenuid = await getresbasedPopularMenumaster(restaurantId);
    let getresmenu = getresmenuid.data.data || [];
    let specialmenulist = getresmenu.map(({ id, name }) => ({
      label: name,
      value: id,
    }));
    setSpecialMenu(specialmenulist);
  };

  const getSubscrptionList = async (outletCode) => {
    let getplanList = await subscriptionPlanId(outletCode);
    // console.log("getplanList",getplanList);
    let getplanidValue = getplanList.data.data || [];

    setSubPlanId(getplanidValue);
    let Selectedplan = getplanidValue.map(({ planId, planName }) => ({
      label: planName,
      value: planId,
    }));
    setSubPlanId(Selectedplan);
  };

  const getSubscrptionWallet = async () => {
    let customerId = selectedusers.value;
    let getplanList = await subscriptionWalletAmount(customerId);
    // console.log("getplanList",getplanList);
    let getplanidValue = getplanList.data.data || [];
    console.log("getplanidValue", getplanidValue);
    //setWalletBal(getplanidValue);
    let walletamount = getplanidValue[0]?.walletAmount;
    console.log("walletamount", walletamount);
    setShowAmount(walletamount);
  };

  const saveupdateSubcribemenulist = async () => {
    // let data = "";
    let setDate1 =
      menulistitem.startDate.getFullYear() +
      "-" +
      (menulistitem.startDate.getMonth() + 1) +
      "-" +
      menulistitem.startDate.getDate();

    let setDate2 =
      menulistitem.endDate.getFullYear() +
      "-" +
      (menulistitem.endDate.getMonth() + 1) +
      "-" +
      menulistitem.endDate.getDate();

    let planId = menulistitem.planId.value;
    let planName = menulistitem.planId.label;

    let data = {
      outletCode: selectedrestarant.value,
      customerId: selectedusers.value,
      plantId: Number(planId),
      planName: planName,
      startDate: setDate1,
      endDate: setDate2,
      totalAmount: menulistitem.totalAmount,
      deliveryType: menulistitem.deliveryType.value,
      actualCount: menulistitem.actualCount,
      weekDays: "",
      paymentMode: "UPI",
      paymentId: "123456",
      paymentDate: setDate1,
    };

    // console.log("data", data);

    let reqforupload;

    if (!isedit) {
      reqforupload = await saveMlmfCustomerMenuREQ(data);
    } else {
      reqforupload = await updateMlmfCustomerMenuReq(data);
    }

    if (reqforupload?.status === 200) {
      setIsview(false);
      setIsedit(false);
      setSubcriptionModal(false);
      getoutletSubscriptionMenulist();
      setSelectedSpecialMenu([]);
      setMenulistitem([]);
      setDate(new Date());
      setendDate(new Date());
      if (!isedit) {
        swal("Success!", "Subscription Menu Added", "success");
      } else {
        swal("Success!", "Subscription Menu Updated", "success");
      }
    } else {
      swal("Oops", `${reqforupload?.data}`, "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setSubcriptionModal(!SubcriptionModal);
      setSelectedSpecialMenu([]);
      setDate(new Date());
      setendDate(new Date());
      setMenulistitem([]);
    }
  };

  const deletemenuitemsubscription = async () => {
    // console.log("setMenulistitem", menulistitem);
    let data = menulistitem;
    let reqformenusubmenu = await deletesubscriptionmenuitem(data);

    // console.log("setMenulistitem", reqformenusubmenu);
    // return false;
    if (reqformenusubmenu.data.status === true) {
      setMenulistitem({});
      setDeletepopup(false);
      setIsview(false);
      setIsedit(false);
      getoutletSubscriptionMenulist();
    } else {
      // getoutletMenulist(
      //   selectedrestarant.value,
      //   selectedusers.value
      // );
      setDeletepopup(false);
      swal("Oops", `${reqformenusubmenu.data.message}`, "error");
    }
  };

  const opnAddNewUserModal = (e) => {
    e.preventDefault();
    setSubcriptionModal(!SubcriptionModal);
    setIsview(false);
    setIsedit(false);
    setFormIsValid(false);
  };

  const onEditSubscription = (items) => {
    console.log("items", items);
    // console.log("items.menuId.value", items.menuId);
    // let selecteduser = menulist.find(
    //   (value, index) => index === items?.rowIndex);

    // console.log("selecteduser",selecteduser);

    let receivedDate = items?.startDate;
    let textDate = new Date(receivedDate);

    let receivedDate2 = items?.endDate;
    let textDate2 = new Date(receivedDate2);

    setDate(new Date(textDate));
    setendDate(new Date(textDate2));

    let deliveryType = { label: items.deliveryType, value: items.deliveryType };

    let planIDnum = `${items.planId} -${items.planName}`;
    console.log("planIDnum", planIDnum);

    let plan = {
      label: items.planName.trim(),
      value: items.planId.toString(),
    };
    console.log("planID1", plan);
    setMenulistitem({
      menuId: selectedspecialMenu.value,
      startDate: textDate,
      endDate: textDate2,
      outletCode: items.outletId,
      customerId: items.customerId,
      planId: plan,
      startDate: textDate,
      endDate: textDate2,
      weekDays: items.weekDays,
      totalAmount: Number(items.totalAmount),
      deliveryType: deliveryType,
      actualCount: Number(items.actualCount),
      planName: items.planName,
    });

    console.log("Edit menulist", menulistitem);

    setSelectedSpecialMenu({
      label: items.menuName,
      value: items.menuId,
    });

    // console.log("items.menuName",  items.menuName);
    // console.log("tems.menuId", items.menuId);
    setSubcriptionModal(!SubcriptionModal);
    setIsedit(true);
    setIsview(false);
    setErrors({});
  };

  const deletetoggle = (items) => {
    setMenulistitem([
      {
        customerId: items.customerId,
        restaurantId: items.restaurantId,
        menuId: items.menuId,
        startDate: items.startDate,
        endDate: items.endDate,
      },
    ]);
    // console.log("setMenulistitem", menulistitem);
    setDeletepopup(true);
    setIsview(false);
    setIsedit(true);
  };

  const onChangeCommonpopupsetOutletvalue = (key, value) => {
    // console.log("key", key);
    // console.log("value", value);

    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    const amountparten = /[0-9]+(\.[0-9]+)?$/;
    const numberRegex = /^\d+$/;

    // if (key == "menuId") {
    //   if (!value) {
    //     addFieldValue = { [value]: null };
    //     errorsLocal["menuId"] = " Please select";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   } else {
    //     addFieldValue = { ["menuId"]: value.value };
    //     errorsLocal["menuId"] = "";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   }
    // }

    if (key == "planId") {
      if (!value) {
        addFieldValue = { ["planId"]: null };
        errorsLocal["planId"] = " Please select";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { ["planId"]: value };
        errorsLocal["planId"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "startDate") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["startDate"] = " Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      //  else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["startDate"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        errorsLocal["startDate"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "endDate") {
      if (!value) {
        addFieldValue = { [key]: null };
        // console.log("addFieldValue", addFieldValue);
        errorsLocal["endDate"] = " Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      //  else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["endDate"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        // console.log("addFieldValue", addFieldValue);
        errorsLocal["endDate"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "totalAmount") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["totalAmount"] = "Enter the Amount";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["totalAmount"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "deliveryType") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["deliveryType"] = "Select Delivery Type";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["deliveryType"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "actualCount") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["actualCount"] = "Enter the Meal count";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!numberRegex.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["actualCount"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["actualCount"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "weekDays") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["weekDays"] = "Select Days Type";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["weekDays"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    const newFormData = { ...menulistitem };
    newFormData[key] = value;

    setMenulistitem(newFormData);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const options = {
    filter: true, 
    search: true, 
    selectableRows: false,
    responsive: "stacked",
    fixedHeader: true,
    tableBodyHeight: "60vh",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },
    download: false,
    print: false,
    onFilterChange: (column, filterList, type, filterOptions, changedColumnIndex) => {
      
    },
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => applyNewFilters()} 
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    onFilterConfirm: (filterList) => {
      // Handle filter confirmation here if needed
    },
    onFilterDialogOpen: () => {
      // Handle filter dialog open event if needed
    },
    onFilterDialogClose: () => {
      // Handle filter dialog close event if needed
    },
    customToolbar: () => {
      return <>{}</>;
    },
  };
  const columns = [
    {
      name: "outletName",
      label: "Restaurant",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "customerFirstName",
      label: "Customer Name",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "customerId",
      label: "Customer ID ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "planId",
      label: "Plan ID ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "planName",
      label: "Plan Name ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "startDate",
      label: "Start Date ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "endDate",
      label: "End Date ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "deliveryType",
      label: "Delivery Type ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    // {
    //   name: "paymentId",
    //   label: "Payment ID",
    //   options: {
    //     filter: false,
    //     sort: true,
    // searchable: true, 
    //     customFilterListOptions: { render: (v) => `UID: ${v}` },
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",

    //   },
    // },
    // {
    //   name: "paymentMode",
    //   label: "Payment Mode ",
    //   options: {
    //     filter: false,
    //     sort: true,
    // searchable: true, 
    //     customFilterListOptions: { render: (v) => `UID: ${v}` },
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",

    //   },
    // },
    //   {
    //   name: "paymentDate",
    //   label: "Payment Date ",
    //   options: {
    //     filter: false,
    //     sort: true,
    // searchable: true, 
    //     customFilterListOptions: { render: (v) => `UID: ${v}` },
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",

    //   },
    // },
    {
      name: "actualCount",
      label: "Meal Count",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "totalAmount",
      label: "Total Amount",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
  ];
  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });
  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12">
          <Card>
            <div class="row">
              <div class="col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <h3 className="me-auto main-hd">Subscription</h3>
                </div>
              </div>
              <div class="col-7 col-md-7 col-lg-7 row">
                <Card.Header
                  className="card-title main-card"
                  style={{ marginLeft: "200px" }}
                >
                  <div class="col-3 col-md-3 col-lg-3 form-group main-frm-grp" style={{zIndex:"800"}}>
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Restaurant
                    </label>
                    <Select
                      options={outletlist}
                      value={selectedrestarant}
                      closeMenuOnSelect={true}
                      // search
                      // name="stateCode"
                      placeholder="Choose"
                      // autoComplete="off"
                      onChange={(event) => {
                        setSelectedrestarant(event);
                        getSubscrptionList(event.value);
                      }}
                    />
                  </div>
                  <div
                    class="col-3 col-md-3 col-lg-3 form-group main-frm-grp"
                    style={{ width: "30.333333%",zIndex:"800" }}
                  >
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Customer
                    </label>
                    <Select
                      options={userlist}
                      value={selectedusers}
                      closeMenuOnSelect={true}
                      placeholder="choose"
                      autoComplete="off"
                      onChange={(event) => {
                        setSelectedusers(event);
                      }}
                    />
                  </div>
                  <div
                    class=" col-2 col-md-2 col-lg-2 mt-4  form-group"
                    style={{ width: "9.333333%" }}
                  >
                    {/* {selectedusers.value && selectedrestarant.value && */}

                    <Button
                      className="mt-2 btn-primary"
                      variant="success dark btn-sm "
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "green",
                        borderRadius: "2px",
                        border: "0px solid",
                      }}
                      onClick={() => {
                        getoutletSubscriptionMenulist();
                        getRestarantPopularlist();
                        getSubscrptionWallet();
                        setListmast(true);
                        // getoutletList();
                      }}
                    >
                      <i
                        // class="fas fa-plus"
                        onClick={() => {
                          // getoutletMenulist();
                          //  getoutletList();
                        }}
                      >
                        Get{" "}
                      </i>{" "}
                    </Button>

                    {/* } */}
                  </div>
                  <div class=" col-2 col-md-2 col-lg-2 mt-4 form-group">
                    <Button
                      className="mt-2"
                      variant="success dark btn-sm"
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "#1F3DB6",
                        borderRadius: "2px",
                        border: "0px solid",
                      }}
                      onClick={(e) => {
                        opnAddNewUserModal(e);
                      }}
                    >
                      <i onClick={() => {}}>Add </i>{" "}
                    </Button>

                    {/* } */}
                  </div>

                  <div
                    class="col-3 col-md-3 col-lg-3 form-group main-frm-grp"
                    style={{ width: "16.333333%" }}
                  >
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Wallet Balance
                    </label>
                    <Input
                      style={{
                        fontWeight: "bold",
                        fontSize: "large",
                        textAlign: "right",
                      }}
                      type="number"
                      name="amount"
                      id="amount"
                      required
                      autoComplete="off"
                      disabled
                      value={showamount}
                    />
                  </div>
                </Card.Header>
              </div>
            </div>

            <Card.Body
              className="scroll-tbl-fix-header"
              style={{ padding: "0.875rem" }}
            >
              <RctCollapsibleCard fullBlock>
                <RctCollapsibleCard fullBlock>
                  <MuiThemeProvider theme={themeTable}>
                    <MUIDataTable
                      title={""}
                      data={userlist}
                      columns={columns}
                      options={options}
                      columOrder={columns}
                      className={"MuiTabCusCls"}
                    />
                  </MuiThemeProvider>
                </RctCollapsibleCard>
              </RctCollapsibleCard>
              {/* <Table responsive stripped>
                <thead>
                  <tr>
                    <th>Restaurant</th>
                    <th>Customer Name</th>
                    <th>Customer ID</th>
                    <th>Plan ID</th>
                    <th>Plan Name</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th> Delivery Type</th>
                    <th> Meal Count</th>
                    <th style={{ textAlign: "right" }}>Total Amount</th>
                    {/* <th> Action</th> 
                  </tr>
                </thead>
                <tbody>
                  {menulist &&
                    menulist.map((items) => {
                      return (
                        <tr>
                          <td>{items.outletName}</td>
                          <td>{items.customerFirstName}</td>
                          <td>{items.customerId}</td>
                          <td>{items.planId}</td>
                          <td>{items.planName}</td>
                          <td>{items.startDate}</td>
                          <td>{items.endDate}</td>
                          <td>{items.deliveryType}</td>
                          <td>{items.actualCount}</td>
                          <td style={{ textAlign: "right" }}>
                            {" "}
                            ₹ {items.totalAmount}
                          </td>
                          <td>
                            <i
                              onClick={() => {
                                onEditSubscription(items);
                              }}
                              style={{ fontSize: "large" }}
                              className="ti-pencil"
                            ></i> 

                             <i
                              onClick={() => {
                                deletetoggle(items);
                              }}
                              style={{
                                fontSize: "large",
                                paddingLeft: "15px",
                              }}
                              className="ti-trash"
                            ></i> 
                          </td>
                        </tr>
                      );
                    })}
                  {listmast == true && menulist?.length <= 0 ? (
                    <div
                      style={{
                        color: "red",
                        textAlign: "center",
                        fontSize: "200%",
                      }}
                    >
                      {" "}
                      No Data Found{" "}
                    </div>
                  ) : (
                    setMenuList
                  )}
                </tbody>
              </Table> */}
            </Card.Body>
          </Card>
        </div>
      </div>

      <Modal
        isOpen={SubcriptionModal || deletepopup}
        // toggle={() => onClose()}
        style={{
          maxWidth: SubcriptionModal && "600px",
        }}
        backdrop="static"
      >
        <ModalHeader>
          {(deletepopup && " Delete Item") ||
            (SubcriptionModal && isedit === false
              ? `Add Subscription Item -- ${selectedusers.label}-${selectedusers.value}`
              : `Update Subscription Item ${selectedusers.label}-${selectedusers.value}-   ${selectedspecialMenu.label}`)}
        </ModalHeader>
        <ModalBody>
          {deletepopup && (
            <>
              <span>
                Are you sure want to delete item ?{" "}
                <strong>{menulistitem?.itemName}</strong>
              </span>
            </>
          )}

          {SubcriptionModal && (
            <>
              <div className="row">
                <div className="col-sm-3 col-md-3 col-xl-3 pop-up-tab">
                  <FormGroup>
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Plan ID
                    </label>
                    <Select
                      options={subPlanId}
                      closeMenuOnSelect={true}
                      placeholder="choose"
                      autoComplete="off"
                      selected=""
                      onChange={(event) => {
                        console.log("eventplanid", event);
                        setSelectedplanId(event);
                        onChangeCommonpopupsetOutletvalue("planId", event);
                      }}
                      value={menulistitem.planId}
                      required
                    />
                    <span style={{ color: "red" }}>{errors["planId"]}</span>
                  </FormGroup>
                </div>

                <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                  <FormGroup>
                    <Label for="totalAmount ">
                      Total Amount<span class="text-danger ">*</span>
                    </Label>

                    <Input
                      type="number"
                      name="amount"
                      id="amount"
                      required
                      autoComplete="off"
                      disabled={isedit}
                      onChange={(e) => {
                        onChangeCommonpopupsetOutletvalue(
                          "totalAmount",
                          e.target.value
                        );
                        setTotalAmount(e.target.value);
                      }}
                      value={menulistitem.totalAmount}
                    />
                    <span style={{ color: "red" }}>
                      {errors["totalAmount"]}
                    </span>
                  </FormGroup>
                </div>

                <div className="col-sm-3 col-md-3 col-xl-3 pop-up-tab">
                  <FormGroup>
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Delivery Type
                    </label>
                    <Select
                      options={deliveryType}
                      closeMenuOnSelect={true}
                      placeholder="choose"
                      autoComplete="off"
                      selected=""
                      onChange={(event) => {
                        setSelectDelivery(event);
                        onChangeCommonpopupsetOutletvalue(
                          "deliveryType",
                          event
                        );
                        // //  console.log("event.value", event);
                      }}
                      value={menulistitem.deliveryType}
                    />
                    <span style={{ color: "red" }}>
                      {errors["deliveryType"]}
                    </span>
                  </FormGroup>
                </div>

                <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                  <FormGroup>
                    <Label for="actualCount ">
                      Meal Count <span class="text-danger ">*</span>
                    </Label>
                    <Input
                      type="number"
                      name="Count"
                      id="Count"
                      required
                      disabled={isedit}
                      autoComplete="off"
                      value={Number(menulistitem.actualCount)}
                      onChange={(e) => {
                        onChangeCommonpopupsetOutletvalue(
                          "actualCount",
                          e.target.value
                        );
                      }}
                    />
                    <span style={{ color: "red" }}>
                      {errors["actualCount"]}
                    </span>
                  </FormGroup>
                </div>

                <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                  <FormGroup>
                    <Label for="startDate">
                      Start Date<span class="text-danger">*</span>
                    </Label>
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      // selectsStart
                      selected={startDate}
                      minDate={today}
                      disabled={isedit}
                      //startDate={rangeStart}
                      // endDate={rangeEnd}
                      onChange={(e) => {
                        setDate(e);
                        // console.log("eeeee", e);
                        onChangeCommonpopupsetOutletvalue("startDate", e);
                      }}
                      value={menulistitem?.startDate}
                    />

                    <span style={{ color: "red" }}>{errors["startDate"]}</span>
                  </FormGroup>
                </div>

                <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                  <FormGroup>
                    <Label for="endDate">
                      End Date<span class="text-danger">*</span>
                    </Label>

                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selectsEnd
                      selected={endDate}
                      minDate={startDate}
                      startDate={startDate}
                      //endDate={rangeEnd}
                      onChange={(e) => {
                        setendDate(e);
                        onChangeCommonpopupsetOutletvalue("endDate", e);
                        // console.log("end", e);
                      }}
                      value={menulistitem?.endDate}
                    />

                    <span style={{ color: "red" }}>{errors["endDate"]}</span>
                  </FormGroup>
                </div>
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          {deletepopup && (
            <>
              <Button
                variant="success"
                onClick={() => {
                  deletemenuitemsubscription();
                  //    deleteitem("Deletemenu");
                }}
              >
                Delete
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setDeletepopup(false);
                }}
              >
                Cancel
              </Button>
            </>
          )}

          {SubcriptionModal && (
            <>
              {isView === false && isedit === false && (
                <Button
                  variant="primary"
                  className={!formIsValid ? "btn-disabled" : "btn-primary"}
                  disabled={!formIsValid}
                  onClick={() => {
                    saveupdateSubcribemenulist();
                  }}
                >
                  Submit
                </Button>
              )}
              {isView === false && isedit === true && (
                <Button
                  variant="contained"
                  className={!formIsValid ? "btn-disabled" : "btn-primary"}
                  disabled={!formIsValid}
                  onClick={() => {
                    saveupdateSubcribemenulist();
                    // console.log("saveupdateSubcribemenulist", );
                  }}
                >
                  Update
                </Button>
              )}

              <Button
                variant="secondary"
                onClick={() => {
                  setErrors({});
                  setSubcriptionModal(false);
                  setIsview(false);
                  setIsedit(false);
                  setMenulistitem([{}]);
                  setSelectedSpecialMenu([null]);
                  setDate(new Date());
                  setendDate(new Date());
                  //  setFormIsValid(false);
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SubscribersMaster;
